module.exports = __webpack_public_path__ + "img/bttn-close-big.ef2007d0.svg";